import nearest from "nearest-date";

const ScheduleComponent = () => {
    return {
        items: [],
        activeDay: null,
        group: null,

        init() {
            this._activeDay();
        },

        _activeDay() {
            const dates = [];
            this.items.forEach((item, index) => {
                dates[index] = item.timestamp * 1000;
            });

            const dateNow = new Date();
            dateNow.setHours(0, 0, 0, 0);

            const nextDates = dates.filter((date) => date - dateNow > 0);
            const offsetIndex = dates.length - nextDates.length;

            const closestIndex = nearest(nextDates, dateNow);
            const closest = this.items[closestIndex + offsetIndex].timestamp;
            const closestDate = new Date(closest * 1000);

            this.activeDay = closestDate.setHours(0, 0, 0, 0) < dateNow ? this.items[0].timestamp : closest;
        },
    };
};

window.schedule = ScheduleComponent;
